import { useState, useEffect } from "react"
import axios from "axios"

export default function TwoFA() {
  const [code, setCode] = useState("")
  const [error, setError] = useState("")
  const [email, setEmail] = useState("")  // Dynamische E-Mail-Adresse des Benutzers

  useEffect(() => {
    // Hole die E-Mail aus der URL
    const urlParams = new URLSearchParams(window.location.search);
    const userEmail = urlParams.get("email"); // Hole E-Mail aus der URL

    if (userEmail) {
      setEmail(userEmail); // Setze die E-Mail in den Zustand
    } else {
      setError("No email provided for 2FA verification.");
    }
  }, []);

  // Funktion, die den Code zur Verifizierung sendet
  const verifyAndStore2FA = async () => {
    try {
      if (!email) {
        setError("No email provided for 2FA verification.");
        return;
      }

      // Sende sowohl den Code als auch die E-Mail an das Backend
      const res = await axios.post("http://localhost:4000/api/2fa/verify-setup", { email, code }, { withCredentials: true })
    
      console.log("Verification Response:", res.data)  // Logge die Antwort vom Backend

      if (res.data.success) {
        // Setze das Token im LocalStorage nach erfolgreicher Verifizierung
        localStorage.setItem("authToken", res.data.token);  // Speichern des Tokens
        localStorage.setItem("email", email);  // Speichern der E-Mail-Adresse

        // Weiterleitung zur Logs-Seite
        window.location.href = "/logs";  
      } else {
        setError("Invalid code. Please try again.");
      }
    } catch (err) {
      setError("Verification failed.")
      console.error("Error:", err)
    }
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white shadow-md rounded-xl p-6 w-full max-w-md text-center">
        <h1 className="text-xl font-semibold mb-4">2-Step Verification</h1>


        
        {/* Der QR-Code wird nicht benötigt, da der Benutzer bereits ein permanentes Secret hat */}
        <input
          type="text"
          placeholder="Enter 6-digit code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") verifyAndStore2FA()
          }}
          className="w-full p-3 border rounded-lg mb-4"
        />
        <button
          onClick={verifyAndStore2FA}
          className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg"
        >
          Verify
        </button>
        {error && <p className="text-red-600 mt-4">{error}</p>}
      </div>
    </div>
  )
}
